import WarehouseStore from './warehouse_store.vue';

export default WarehouseStore;
